import { deepClone } from '@hc-frontend/utils'

/**
 * Add the childOnly property to the plan object if the product is eligible for a child only purchase
 * @param plans The object the plans returned by the quote
 * @param childOnlyProductLines The child only product lines that are eligible for child only purchases
 */

function addChildOnlyPropertyToPlans(plans, childOnlyProductLines) {
  const plansCopy = deepClone(plans)
  for (const planId in plansCopy) {
    const plan = plansCopy[planId]
    const productLine = childOnlyProductLines.find(
      productLine => productLine.productId === plan.productId
    )
    let isChildOnly = false
    if (productLine) {
      isChildOnly = productLine.membersEligibleForChildOnly
    }
    plan.isChildOnly = isChildOnly
  }
  return plansCopy
}
export default addChildOnlyPropertyToPlans
